import { isPlatformBrowser } from '@angular/common';
import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, Input } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-nav-bar',
  imports: [CommonModule, RouterModule, MatIconModule],
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent {
  @Input() variant: 'default' | 'alt' = 'default';

  scrolled = false;
  mobileMenuOpen = false;
  isHomePage = false;
  isPropertiesPage = false;

  private readonly isBrowser: boolean;

  constructor(
    private readonly router: Router,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    // Detectar si estamos en la página de inicio o propiedades
    this.updatePageStatus();

    // Actualizar cuando cambie la ruta
    this.router.events.subscribe(() => {
      this.updatePageStatus();
    });
  }

  private updatePageStatus() {
    this.isHomePage = this.router.url === '/' || this.router.url.startsWith('/#');
    this.isPropertiesPage = this.router.url.startsWith('/properties');
  }

  toggleFilters() {
    // Emit event to properties component or handle filter toggle
    // This will be caught by properties component
    const event = new CustomEvent('toggleFilters', { detail: { open: true } });
    window.dispatchEvent(event);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    // Prevenir scroll del body cuando el menú está abierto
    if (!this.isBrowser) return;
    if (this.mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    if (!this.isBrowser) return;
    document.body.style.overflow = '';
  }


}
